import {
  ApiPermission,
  EmployeeFieldPermission,
  EmployeeFieldPermissionsKeys,
  PermissionsKeys,
  PermissionType,
} from "@/types/role.types.ts";
import { z } from "zod";

export enum PermissionOptionsInterface {
  switch = "switch",
  select = "select",
}

export type PermissionFieldPath =
  | `employee_custom_field_permissions.${string}`
  | `employee_custom_table_field_permissions.${number}.fields_permissions.${string}`
  | `employee_custom_table_field_permissions.${number}.manage_table`
  | `employee_custom_table_field_permissions.${number}.history`
  | `employee_custom_table_field_permissions.${number}.effective_from`
  | `employee_custom_table_field_permissions.${number}.changed_by`
  | `api_permissions.${keyof typeof ApiPermission}`
  | `employee_field_permissions.${keyof typeof EmployeeFieldPermission}`
  | `employee_folder_permissions.${number}`
  | `employee_workflow_permissions.${number}.run`
  | `employee_workflow_permissions.${number}.executions`;

export type PermissionValueGetter = (field: PermissionFieldPath) => PermissionType | undefined;

export interface PermissionDependencyState {
  disabled?: boolean;
  value?: PermissionType;
}

export interface PermissionDependency {
  fields: PermissionFieldPath[];
  getState: (getPermission: PermissionValueGetter) => PermissionDependencyState;
}

export interface PermissionsItem {
  title: string;
  description?: string;
  field: PermissionFieldPath;
  availableOptions: PermissionType[];
  renderAs: PermissionOptionsInterface;
  availableOptionsDescription?: Record<keyof typeof PermissionType, string>;
  customPermissionTypesTexts?: Partial<Record<PermissionType, string>>;
  children?: PermissionsItem[];
  dataAccessDependent?: boolean;
  dependency?: PermissionDependency;
}

export interface PermissionsSectionGroup {
  title: string | null;
  description?: string;
  items: PermissionsItem[];
  hiddenWhenField?: PermissionFieldPath;
  hiddenWhenValue?: PermissionType;
}

export interface PermissionsSection {
  title: string;
  groups: PermissionsSectionGroup[];
  sectionHeader?: string;
}

export type ApiPermissionsSchemaType = {
  [key in PermissionsKeys]: z.ZodType<PermissionType>;
};

export type EmployeePermissionSchemaType = {
  [key in EmployeeFieldPermissionsKeys]: z.ZodType<PermissionType>;
};
